var top1;
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    var alertIcon =
      '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="15" style="overflow:visible;enable-background:new 0 0 32 32" viewBox="0 0 32 32" width="15" xml:space="preserve"><g><g id="Error_1_"><g id="Error"><circle cx="16" cy="16" id="BG" r="16" style="fill:#D72828;"></circle><path d="M14.5,25h3v-3h-3V25z M14.5,6v13h3V6H14.5z" id="Exclamatory_x5F_Sign" style="fill:#E6E6E6;"></path></g></g></g></svg>';
    event.preventDefault();
    const previousValue = parseInt(this.input.value, 10);
    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();

    const qty = parseInt(this.input.value, 10);
    const max_qty = parseInt(this.input.getAttribute("data-max"), 10);
    if (max_qty && qty > max_qty) {
      this.input.value = max_qty;
      $(this).siblings(".qty_error").show().html(
        alertIcon +
        "<span>We're sorry. The quantity you requested exceeds what's currently in stock and has been updated to reflect the maximum available. Please contact us if you would like more or an alternative.</span>"
      ).css("color", "rgb(196, 0, 0)");
      $(this).css("border-color", "rgb(196, 0, 0)");
    } else {
      $(this).siblings(".qty_error").hide();
      $(this).css("border-color", "");
    }

    if (previousValue !== parseInt(this.input.value, 10))
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
        event,
        this.mainDetailsToggle.querySelector("summary")
      )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
            "transitionend",
            addTrapFocus
          );
      }, 50);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
      // $('.mobile-facets__main').scrollTop(0);
      document.querySelector(".mobile-facets__main").scrollTop = 0;
      // document.querySelector('.menu-drawer__navigation').scrollTop = 0;
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document
      .getElementsByTagName("html")[0]
      .classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    var doc = document.documentElement;

    // scroll background on filter click

    // top1 = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    // $("body").css({
    //   position: "fixed",
    //   top: "-" + top1 + "px",
    //   overflow: "hidden",
    //   width: "100%",
    // });

    $(".facets-wrapper").addClass("stickyFilter");
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document
      .getElementsByTagName("html")[0]
      .classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    $("body").css({
      position: "",
      top: "",
      overflow: "",
    });
    console.log(top1);
    $("html, body").animate(
      {
        scrollTop: top1,
      },
      30
    );

    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom"
        )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
      this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
        this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) +
        1 -
        this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateSliders();
    this.resetQuantity();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  // Client: picking a new colour/variant kept whatever quantity was set for
  // the previous one (e.g. pick Qty 6, switch colour, it's still 6) -
  // quantity should never carry over, always back to 1. The buy box's
  // quantity picker (sections/new_product_page_section.liquid,
  // assets/changes.js) is its own small widget with several pieces kept in
  // sync with each other via "change" events - the real submitted desktop
  // input (.pdpjs-qty__num), its hidden backing <select> (.dropdown_qtycls),
  // the mobile equivalents, and the "50+" manual-entry box's visibility -
  // so the reset has to go through that same change-event path rather than
  // just setting .pdpjs-qty__num.value directly, or the dropdown/mobile/
  // manual-entry pieces would end up disagreeing with it.
  resetQuantity() {
    var deskSel = document.querySelector(".dropdown_qtycls");
    if (deskSel) {
      // A previous 50+ manual entry appends its own out-of-range <option>
      // (new_product_page_section.liquid) - without removing it first,
      // setting .value = "1" while that's still the selected option is a
      // no-op on a native <select>.
      deskSel.querySelectorAll("option.lg_qty").forEach(function (opt) {
        opt.remove();
      });
      deskSel.value = "1";
      deskSel.dispatchEvent(new Event("change", { bubbles: true }));
    }

    var mobileSel = document.querySelector(".dropdown_qtycls_mobile");
    if (mobileSel) {
      mobileSel.value = "1";
      mobileSel.dispatchEvent(new Event("change", { bubbles: true }));
    }

    // commitManualQty (assets/changes.js) stamps the last-committed value
    // onto both quantity inputs via jQuery's .data() so its own "input"
    // handler can tell a genuine edit from a spurious mobile-keyboard event
    // - left stale at the old quantity, typing that same old number again
    // right after a reset would look like no change and the Update button
    // wouldn't reappear.
    if (window.jQuery) {
      window.jQuery(".pdpjs-qty__num, .pdpjs-qty__num_mobile").data("committedQty", 1);
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateSliders() {
    // setTimeout(function(){
    //   var sliders = document.querySelectorAll('.slick-dots');
    //   sliders.forEach(function(item){
    //   var slideCount = item.children.length;
    //   console.log("slideCount",slideCount)
    //   if (slideCount == 1){
    //     var slick_dots = document.querySelector('.tm_product-main-img-slide .slick-dots')
    //     slick_dots.style.display = "none";
    //     setTimeout(function(){
    //       var mobile_slick_dots = document.querySelector('.tm_product-img .slick-dots')
    //       mobile_slick_dots.style.display = "none";
    //     }, 500);
    //     console.log("iffffffffff");
    //   }else{
    //     console.log("eleeeeeeeee");
    //   }
    //   })
    // }, 60);
  }

  updateVariantInput() {
    $(document).ready(function () {
      $(".tm_product-view-img.slick-active").on("click", function () {
        console.log("click");
        $(this).addClass("active-img");
      });
    });
    // alert();
    // Model (SKU) and Colour text shown in the photo popup must reflect
    // whichever variant is currently selected, regardless of which swatch
    // (White -> Black or Black -> White) the customer just picked - this
    // used to only run per product-form found below, which left it stale
    // when no matching product-form existed on the page.
    var sku = (this.currentVariant && this.currentVariant.sku) ? this.currentVariant.sku : "";

    var varSkuEl = document.querySelector(".tm_product-view-var .var-sku");
    var varSkuRow = document.querySelector(".tm_product_model_row");
    if (varSkuEl) {
      varSkuEl.textContent = sku;
      if (varSkuRow) {
        varSkuRow.style.display = sku ? "" : "none";
      }
    }

    var popupColourEl = document.querySelector(".tm_product-view-var .popupcolor_selected");
    if (popupColourEl && this.currentVariant && this.currentVariant.title) {
      popupColourEl.textContent = this.currentVariant.title;
    }

    // Client: the "Model:" text shown under the price on the main page never
    // changed when a different colour was picked - it kept showing whichever
    // variant the page had loaded with. Same root cause as the comment above:
    // this write used to live inside the productForms loop below, and
    // productForms is empty on this theme (its add-to-cart form doesn't use
    // Dawn's #product-form-{section} id), so the loop body - and this update
    // with it - never ran on a real click. Driven directly off currentVariant
    // instead, same as varSkuEl/popupColourEl just above.
    var modelContainer = document.querySelector(".tm_product-modal");
    var modelSpan = document.querySelector(".tm_product-modal span.tm_lg-font");
    if (modelContainer && modelSpan) {
      if (sku) {
        modelSpan.innerHTML = `Model: ${sku}`;
        modelContainer.style.display = "";
      } else {
        modelSpan.innerHTML = "";
        modelContainer.style.display = "none";
      }
    }

    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;

      if (document.querySelector(".tm_add_to-list .second_wishlist_button")) {
        document
          .querySelector(".tm_add_to-list .second_wishlist_button")
          .setAttribute("data-variant_id", this.currentVariant.id);
        document
          .querySelector(".tm_add_to-list")
          .setAttribute("data-variant", this.currentVariant.title);
        // document.querySelector(".mobile_wishlist_button").setAttribute("data-variant_id", this.currentVariant.id);
      }
      if (document.querySelector(".amazon_wishlist_trigger")) {
        document.querySelectorAll(".amazon_wishlist_trigger").forEach((btn) => {
          btn.setAttribute("data-variant_id", this.currentVariant.id);
          btn.setAttribute("data-variant", this.currentVariant.title);
        });
      }

      var breadcrumbSpan = document.querySelector(".breadcrumb__list .breadcrumb__divider + span");
      if (breadcrumbSpan && sku) {
        breadcrumbSpan.innerHTML = sku;
      }
      input.dispatchEvent(new Event("change", { bubbles: true }));
      $(input).trigger("change");
      //BOLD PRE
      // if (
      //   typeof BOLD === "object" &&
      //   typeof BOLD.pre === "object" &&
      //   typeof BOLD.pre.events === "object" &&
      //   typeof BOLD.pre.events.emit === "function"
      // ) {
      //   BOLD.pre.events.emit("variant_changed", {
      //     variant: this.currentVariant,
      //   });
      // }
      //End BOLD PRE
    });

    // Gallery photo on variant change: same trap as the price below. This
    // call used to sit inside the productForms loop above, which never runs
    // in this theme, so picking a different colour never moved the gallery -
    // it kept showing the previous colour's photo. Run it off the selected
    // variant directly instead of off a form lookup that matches nothing.
    if (this.currentVariant) {
      this.goToVariantImage(this.currentVariant);
    }

    // Price on variant change: this used to only run inside the
    // productForms loop above, but this theme's add-to-cart form isn't
    // #product-form-{section}/#product-form-installment-{section} (that's
    // Dawn's default id, not this theme's), so productForms is always empty
    // here and this never ran - switching colour/size kept showing the
    // previously-selected variant's price until a full page reload. Same
    // root cause, same fix as the Model/Colour popup text further up:
    // decouple from a form lookup that doesn't match anything in this
    // theme's markup.
    if (this.currentVariant) {
      var $VariantClassName = ".price_variant--" + this.currentVariant.id;
      var variantPriceEl = document.querySelector($VariantClassName);
      var rawPrice = null;
      var rawComparePrice = null;

      if (variantPriceEl && variantPriceEl.dataset.price !== undefined && variantPriceEl.dataset.price !== "") {
        var strP = String(variantPriceEl.dataset.price).trim();
        var valP = parseFloat(strP.replace(/[^\d.]/g, ''));
        if (!isNaN(valP)) {
          if (strP.indexOf('.') !== -1) {
            rawPrice = Math.round(valP * 100);
          } else {
            rawPrice = valP;
          }
        }
        if (variantPriceEl.dataset.compareprice !== undefined && variantPriceEl.dataset.compareprice !== "") {
          var strC = String(variantPriceEl.dataset.compareprice).trim();
          var valC = parseFloat(strC.replace(/[^\d.]/g, ''));
          if (!isNaN(valC)) {
            if (strC.indexOf('.') !== -1) {
              rawComparePrice = Math.round(valC * 100);
            } else {
              rawComparePrice = valC;
            }
          }
        }
      }

      if ((rawPrice === null || isNaN(rawPrice)) && this.currentVariant.price !== undefined && this.currentVariant.price !== null) {
        rawPrice = Number(this.currentVariant.price);
      }

      if ((rawComparePrice === null || isNaN(rawComparePrice)) && this.currentVariant.compare_at_price !== undefined && this.currentVariant.compare_at_price !== null) {
        rawComparePrice = Number(this.currentVariant.compare_at_price);
      }

      if (rawPrice !== null && !isNaN(rawPrice)) {
        var $CurrentVariantPrice = rawPrice > 0 ? rawPrice / 100 : 0;
        var tmPriceInt = $CurrentVariantPrice.toString().split(".")[0];
        var tmPriceDec = $CurrentVariantPrice.toFixed(2).split(".")[1] || "00";

        var selectedVariantId = this.currentVariant ? this.currentVariant.id : "";

        // Two earlier attempts at this both still blinked on a real trade
        // account, for provable reasons, and they teach what the fix has to
        // be:
        //   1. Timed re-writes (150ms/400ms/...) - frame-by-frame video
        //      showed them winning eventually, but each stale write from
        //      Bold's rescan / changes.js's reformatter got a painted frame
        //      in first: wrong-right-wrong-right for ~1.2s.
        //   2. Hiding the price behind Bold's anti-flash animation while it
        //      settled - no wrong figure, but the price visibly vanishing
        //      and reappearing IS a blink to the shopper.
        // What actually eliminates the flash is correcting stale writes
        // BEFORE they paint: MutationObserver callbacks run as microtasks,
        // ahead of the next paint - changes.js's own comment on this very
        // element relies on that exact property. So: write the price once,
        // then keep an observer on each price element for a settling window;
        // any outside write that lands (Bold, reformatter) is corrected in
        // the same frame it happened, so the wrong figure never becomes
        // pixels. The observer disconnects when the next variant click
        // starts its own guard, or after the fight is over.
        var writePriceInto = function (el) {
          el.dataset.price = $CurrentVariantPrice.toFixed(2);
          el.dataset.variantId = selectedVariantId;
          var $el = $(el);
          var $sm = $el.find(".tm_price_sm");
          var $span = $el.find("span").not(".tm_pound-sign, .tm_price_sm").first();
          if ($span.length || $sm.length) {
            if ($span.length) {
              $span.text(tmPriceInt);
            } else {
              $el.find("span").first().text(tmPriceInt);
            }
            if ($sm.length) {
              $sm.text(tmPriceDec);
            }
          } else {
            // Bold's rewrite replaces the whole innerHTML with flat text
            // ("£1.60"), destroying the pound/int/decimal spans the branch
            // above writes into - with nothing to find, it would silently
            // do nothing and the stale flat text would stay. Rebuild the
            // element's own original markup (same structure/classes the
            // section renders and changes.js's reformatter produces).
            el.innerHTML =
              '<sup class="tm_pound-sign tm_sm-font">£</sup><span>' + tmPriceInt +
              '</span><sup class=" tm_price_sm tm_sm-font">' + tmPriceDec + '</sup>';
          }
        };
        // The element renders pound/int/decimals as separate tags with no
        // dot between them, so its textContent is "£200" for £2.00 -
        // comparing digits-only is the representation-independent check
        // that matches both that structured form and Bold's flat "£2.00".
        // (An earlier dot-based comparison here could never match the
        // structured form, which made the guard below rewrite forever -
        // the cap on corrections exists so no future check bug can hang
        // the page like that again.)
        var expectedDigits = tmPriceInt + tmPriceDec;
        var priceIsCorrect = function (el) {
          return String(el.textContent).replace(/\D/g, "") === expectedDigits;
        };

        // One shared guard slot on the element class itself: a newer
        // variant click replaces (and disconnects) the previous click's
        // observers, so a superseded sequence can never drag its stale
        // price back over the newer one.
        if (window.__wcPriceGuards) {
          window.__wcPriceGuards.forEach(function (obs) { obs.disconnect(); });
        }
        window.__wcPriceGuards = [];

        $(".product_def_price").each(function () {
          var el = this;
          writePriceInto(el);
          // Hard ceiling on corrective rewrites. The video showed 2-3 stale
          // writes per settle, so 15 is far beyond any legitimate fight -
          // its real job is making a rewrite loop (our own write re-firing
          // the callback against a buggy correctness check) terminate
          // instead of hanging the page, which the dot-comparison bug
          // described above actually did once.
          var corrections = 0;
          var guard = new MutationObserver(function () {
            // Re-entrancy: our own corrective write below mutates the
            // element and re-fires this callback; the correctness check
            // makes that pass a no-op instead of a loop.
            if (!priceIsCorrect(el)) {
              corrections++;
              if (corrections > 15) {
                guard.disconnect();
                return;
              }
              writePriceInto(el);
            }
          });
          guard.observe(el, { childList: true, characterData: true, subtree: true });
          window.__wcPriceGuards.push(guard);
          // Bold's own longest self-scheduled work on these elements is its
          // 2s anti-flash window; 4s of guarding comfortably outlives every
          // writer seen in the video timeline, then gets out of the way.
          setTimeout(function () { guard.disconnect(); }, 4000);
        });

        var tm_cart_inner = document.querySelector(
          ".tm_cart_product-price .tm_product-price-inner"
        );
        if (tm_cart_inner) {
          var tmCartSpan = tm_cart_inner.querySelector("span");
          if (tmCartSpan) {
            tmCartSpan.textContent = tmPriceInt;
          }
        }

        if (rawComparePrice !== null && !isNaN(rawComparePrice) && rawComparePrice > rawPrice) {
          var $CurrentComparePrice = rawComparePrice / 100;
          var saveAmount = ($CurrentComparePrice - $CurrentVariantPrice).toFixed(2);
          var savePercent = Math.round((($CurrentComparePrice - $CurrentVariantPrice) / $CurrentComparePrice) * 100);

          $(".tm_product-price-offer").each(function () {
            $(this).find(".exp_price span").text($CurrentComparePrice.toFixed(2));
            $(this).find(".total_save").text(saveAmount);
            $(this).find(".totalSavePersantage").text(" (" + savePercent + "%)");
            $(this).show();
          });
        } else {
          $(".tm_product-price-offer").hide();
        }

        // Trade customers see this price via Bold Custom Pricing, which
        // rewrites every .money-classed element (product_def_price carries
        // that class, see new_product_page_section.liquid) against its own
        // cached figures - but only on its own schedule (page load, or its
        // own "update" event). It never hears about a variant swap on its
        // own, so the correct price this loop just wrote in got silently
        // painted over a moment later with the FIRST variant's price still
        // showing, while the model number above it had already changed -
        // exactly the "model updates, price doesn't" symptom reported.
        // Nudging Bold's own update event here is the same fix already
        // used for this identical race in cart.js and tm-wishlist.js.
        try {
          if (window.BOLD && window.BOLD.pre && window.BOLD.pre.events) {
            window.BOLD.pre.events.emit("update");
          }
        } catch (e) { }
      }
    }
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
          }`
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  goToVariantImage(variant) {
    if (!variant) return;

    // Standard theme media gallery element update (Dawn / Dawn-based themes)
    const imageMedia = variant.featured_media || variant.featured_image;
    if (variant.featured_media) {
      const mediaGalleries = document.querySelectorAll(
        `[id^="MediaGallery-${this.dataset.section}"]`
      );
      mediaGalleries.forEach((mediaGallery) => {
        if (typeof mediaGallery.setActiveMedia === "function") {
          mediaGallery.setActiveMedia(
            `${this.dataset.section}-${variant.featured_media.id}`,
            true
          );
        }
      });
    }

    // Slick slider (.tm_product-main-img-slide) update
    if (imageMedia) {
      const mediaId = imageMedia.id || variant.featured_media_id;
      // variant.featured_media in the variant JSON carries an id and a
      // preview_image but NO top-level `src`. Reading only imageMedia.src left
      // this empty, and the `if (!targetSlide && cleanImageSrc)` guard below
      // then skipped the entire src-matching fallback - so nothing was ever
      // found and the gallery stayed on the previous colour. Fall through to
      // preview_image / featured_image, which do carry a usable src.
      const rawSrc =
        imageMedia.src ||
        (imageMedia.preview_image && imageMedia.preview_image.src) ||
        (variant.featured_image && variant.featured_image.src) ||
        "";
      const cleanImageSrc = rawSrc ? rawSrc.split(":").pop().split("?")[0] : "";

      let targetSlide = null;

      if (mediaId) {
        // Match on the media id the gallery now renders (data-media-id on each
        // figure), preferring a real slide over one of slick's infinite-scroll
        // clones - a clone carries the same id and can come first in document
        // order, which would resolve to a phantom slide index.
        const byMediaId = document.querySelectorAll(
          `[data-media-id="${mediaId}"], [data-media-id="${this.dataset.section}-${mediaId}"]`
        );
        for (let el of byMediaId) {
          const ownSlide = el.closest(".slick-slide");
          if (ownSlide && ownSlide.classList.contains("slick-cloned")) continue;
          targetSlide = el;
          break;
        }
      }

      if (!targetSlide && cleanImageSrc) {
        // ".tm_product_view-main-slide img" is the product page's own gallery
        // and was missing from this list, so selecting a colour searched only
        // the other sliders and never found (or moved) the gallery the
        // customer is actually looking at. Cloned slides are skipped: slick
        // duplicates slides for infinite scrolling and a clone can appear
        // first in document order, which would resolve to a phantom index.
        const mainImgs = document.querySelectorAll(
          ".tm_pro-main-img, .figure_slot img, .tm_product-main-img-slide img, .tm_product_view-main-slide img"
        );
        for (let img of mainImgs) {
          const ownSlide = img.closest(".slick-slide");
          if (ownSlide && ownSlide.classList.contains("slick-cloned")) continue;
          const srcAttr = img.getAttribute("src") || img.src || "";
          const cleanSrc = srcAttr.split(":").pop().split("?")[0];
          if (
            cleanSrc &&
            (cleanSrc === cleanImageSrc ||
              cleanSrc.endsWith(cleanImageSrc) ||
              cleanImageSrc.endsWith(cleanSrc))
          ) {
            targetSlide = img;
            break;
          }
        }
      }

      if (targetSlide) {
        const slide = targetSlide.closest(".slick-slide");
        if (slide) {
          const index = slide.getAttribute("data-slick-index");
          if (
            index !== null &&
            index !== undefined &&
            typeof jQuery !== "undefined"
          ) {
            // Move whichever slider actually contains the matched photo. This
            // was hardcoded to ".tm_product-main-img-slide", so even when the
            // right photo was found in the product page gallery the goTo went
            // to a different slider and the gallery stayed on the old colour.
            const ownSlider = targetSlide.closest(".slick-slider");
            const $slider = ownSlider
              ? $(ownSlider)
              : $(".tm_product-main-img-slide");
            if ($slider.length && $slider.hasClass("slick-initialized")) {
              $slider.slick("slickGoTo", parseInt(index, 10));
            }
          }
        }
      }
    }
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initHoverPreview();
  }

  initHoverPreview() {
    // Only wire the hover preview up where a real hovering pointer exists.
    // On touch screens there is no hover - and worse, mobile browsers treat
    // a first tap on an element whose mouseenter handler changes the page as
    // the "hover": the mouse events fire, the gallery visibly swaps photos,
    // and the tap's click is swallowed, so picking a colour needed TWO taps.
    // (This surfaced when goToVariantImage was fixed - before that the hover
    // handler was effectively a no-op, so the first tap clicked through.)
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
      return;
    }
    const elements = this.querySelectorAll("label, input[type='radio']");
    elements.forEach((element) => {
      element.addEventListener("mouseenter", () => {
        this.handleHover(element);
      });
      element.addEventListener("mouseleave", () => {
        this.handleHoverLeave();
      });
    });
  }

  handleHover(element) {
    let input = element;
    if (element.tagName === "LABEL") {
      const forAttr = element.getAttribute("for");
      if (forAttr) {
        input =
          document.getElementById(forAttr) ||
          this.querySelector(`#${CSS.escape(forAttr)}`);
      }
    }
    if (!input || input.type !== "radio") return;

    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    const fieldset = input.closest("fieldset");
    if (!fieldset) return;
    const optionIndex = fieldsets.indexOf(fieldset);
    if (optionIndex === -1) return;

    const hoveredValue = input.value;
    const variants = this.getVariantData();
    if (!variants || !variants.length) return;

    const currentSelected = fieldsets.map((fs) => {
      const checked = fs.querySelector("input:checked");
      return checked ? checked.value : null;
    });

    const targetOptions = [...currentSelected];
    targetOptions[optionIndex] = hoveredValue;

    // 1. Match full options combination
    let match = variants.find((v) => {
      return v.options.every((optVal, idx) => {
        return (
          targetOptions[idx] === null ||
          targetOptions[idx] === undefined ||
          optVal === targetOptions[idx]
        );
      });
    });

    // 2. Fallback to first variant containing hovered option value with featured image/media
    if (!match) {
      match = variants.find(
        (v) =>
          v.options[optionIndex] === hoveredValue &&
          (v.featured_image || v.featured_media)
      );
    }

    if (match) {
      this.goToVariantImage(match);
    }
  }

  handleHoverLeave() {
    const currentVariant = this.currentVariant || this.getSelectedVariant();
    if (currentVariant) {
      this.goToVariantImage(currentVariant);
    }
  }

  getSelectedVariant() {
    const variants = this.getVariantData();
    if (!variants) return null;
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    const selected = fieldsets.map((fs) => {
      const checked = fs.querySelector("input:checked");
      return checked ? checked.value : null;
    });
    return variants.find((v) => {
      return v.options.every((optVal, idx) => optVal === selected[idx]);
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      const checkedRadio = Array.from(
        fieldset.querySelectorAll("input")
      ).find((radio) => radio.checked);
      return checkedRadio ? checkedRadio.value : "";
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

// document.addEventListener("DOMContentLoaded", updateSliders);
//   function updateSliders(){
//   setTimeout(function(){
//      var sliders = document.querySelectorAll('.slick-dots');
//     // var sliders = document.querySelectorAll('.slick-dots .slick-active');
//     sliders.forEach(function(item){
//     var slideCount = item.children.length;
//     console.log("slideCount",slideCount)
//     if (slideCount == 1){
//       var slick_dots = document.querySelector('.tm_product-main-img-slide .slick-dots')
//       slick_dots.style.display = "none";
//       setTimeout(function(){
//         var mobile_slick_dots = document.querySelector('.tm_product-img .slick-dots')
//         mobile_slick_dots.style.display = "none";
//       }, 500);
//       console.log("ifffffffffff normal");
//     }else{
//       console.log("elseeeeeeeee normal");
//     }
//     })
//   }, 60);
// }

const spans = document.querySelector(".list_of_mode span");
if (spans) {
  spans.addEventListener("click", function () {
    this.classList.toggle("active");
  });
}

// let radioInputs = document.querySelectorAll('input[type="radio"]');
// radioInputs.forEach(function(radio) {
//     radio.addEventListener('change', function(event) {
//         let selectedValue = event.target.value;
//         let selectOptions = document.querySelectorAll('.product-form__input .select__select option');
//         selectOptions.forEach(function(option) {
//             let optionText = option.innerText.trim();
//             let dataOption = option.getAttribute('data_option');

//             if (dataOption.includes(selectedValue) || optionText.includes(selectedValue)) {

//                 let fieldsets = document.querySelectorAll('.tm_product-var-res fieldset');
//                 fieldsets.forEach(function(fieldset) {
//                   let checkedInputs = fieldset.querySelectorAll('input[type="radio"]');
//                   checkedInputs.forEach(function(input) {
//                       let input_val = input.value;

//                       if (dataOption.includes(input_val) || optionText.includes(input_val)){
//                         console.log("optionText",optionText,'------' ,dataOption, '---------',selectedValue);
//                         console.log("input_val",input_val);

//                         let fieldsets = document.querySelectorAll('.tm_product-var-res fieldset');
//                         let checkedInputs = fieldset.querySelectorAll('input[type="radio"]');
//                         checkedInputs.forEach(function(input) {
//                           if (input.getAttribute('value') === 'input_val') {
//                              input.addAttribute("active");
//                           }
//                         });
//                       }else{
//                          let fieldsets = document.querySelectorAll('.tm_product-var-res fieldset');
//                         let checkedInputs = fieldset.querySelectorAll('input[type="radio"]');
//                         checkedInputs.forEach(function(input) {
//                          input.classList.remove("active");
//                         });
//                       }
//                   });
//                 });
//             }
//         });
//     });
// });

// $(".tm_var-btn").on("click", function (e) {
//   e.preventDefault();

//   const handle = $(this).attr('href');
//   const productUrl = `${window.location.origin}${handle}`;

//   $.ajax({
//     url: productUrl,
//     method: 'GET',
//     success: function(responseHTML) {
//       setTimeout(function(){
//       const parser = new DOMParser();
//       const html = parser.parseFromString(responseHTML, 'text/html');

//       console.log("HTML:", html);
//       console.log("Response HTML:", responseHTML);

//       var headerData = $(html).find('#shopify-section-header').html();
//       $('#shopify-section-header').empty().html(headerData);
//       var mainData = $(html).find('#MainContent').html();
//       $('#MainContent').empty().html(mainData);

//       setTimeout(initializeSliders, 5000);

//       if (window.history && window.history.pushState) {
//         window.history.pushState("", "", handle);
//       }

//       $("html, body").animate({ scrollTop: 0 }, 0);
//       }, 600);
//     },
//     error: function(jqXHR, textStatus, errorThrown) {
//       console.error('Failed to load content:', textStatus, errorThrown);
//     }
//   });
// });

// function initializeSliders() {

//   $('.tm_product_view-thumbs-slide').slick('unslick');
//   $('.tm_product_view-main-slide').slick('unslick');
//   $(".tm_product_view-thumbs-slide").slick({
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     asNavFor: ".tm_product_view-main-slide",
//     arrows: false,
//     dots: false,
//     infinite: false,
//     focusOnSelect: true,
//     pauseOnHover: true
//   });
//   $(".tm_product_view-main-slide").slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     asNavFor: ".tm_product_view-thumbs-slide",
//     arrows: false,
//     dots: false,
//     draggable: false,
//     infinite: true,
//     focusOnSelect: true,
//     fade: true,
//     pauseOnHover: true,
//     speed: 250,
//     responsive: [
//       {
//         breakpoint: 992,
//         settings: {
//           swipe: false
//         }
//       }
//     ]
//   });
// }
$(document).on("mouseenter", ".tm_colle_colour li", function () {
  var var_img = $(this).data("img");
  $(this).parents(".tm_collection-item").find("img").attr("srcset", var_img);
});
$(document).on("mouseleave", ".tm_colle_colour li", function () {
  var var_main_img = $(this)
    .parents(".tm_collection-item")
    .find(".colle_img")
    .data("main");
  $(this)
    .parents(".tm_collection-item")
    .find("img")
    .attr("srcset", var_main_img);
});

// $(window).on('load', function() {
//   setTimeout(function() {
//    $(".tm_product_thumbs li,.tm_product_thumbs-slide li").css("opacity","1");
//   }, 30);
// });
$(document).ready(function () {
  $(".product-form__input label").click(function () {
    $(".tm_product_thumbs-slide li").css("opacity", "1");
  });
});

function checkInput() {
  var inputField = document.getElementById("inputField").value;

  if (inputField.trim() === "") {
    alert("Input field is blank. Please fill it in.");
    return false;
  } else {
    alert("Input is filled.");
    return true;
  }
}
$("#create_list_main").click(function () {
  var inputField = document.getElementById("New_list").value;
  console.log("inputField", inputField);
  if (inputField.trim() === "") {
    $(".error_msg").show();
    return false;
  } else {
    $(".error_msg").hide();
    return true;
  }
});

if (window.innerWidth < 767) {
  const pageKey = "scrollPosition_" + window.location.pathname;
  function saveScrollPosition() {
    console.log("Saving scroll position:", window.scrollY);
    localStorage.setItem(pageKey, window.scrollY);
  }
  function restoreScrollPosition() {
    const savedPosition = localStorage.getItem(pageKey);
    if (savedPosition) {
      setTimeout(() => {
        window.scrollTo({
          top: parseInt(savedPosition, 10),
          behavior: "smooth",
        });
        setTimeout(() => {
          localStorage.removeItem(pageKey);
        }, 5000);
      }, 100);
    } else {
      // console.log('No scroll position found to restore.');
    }
  }

  document.querySelectorAll(".Manuals_Guides a").forEach((link) => {
    link.addEventListener("click", function () {
      saveScrollPosition();
    });
  });
  function handleLoadAndVisibility() {
    window.addEventListener("load", restoreScrollPosition);
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "visible") {
        restoreScrollPosition();
      }
    });
  }
  handleLoadAndVisibility();
  const observer = new MutationObserver(() => {
    restoreScrollPosition();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

if (
  window.location.pathname.includes("/collections/") &&
  !window.location.pathname.includes("/products/")
) {
  // const isMobile = /Mobi|Android/i.test(navigator.userAgent);

  // if (isMobile) {
  function saveScrollPosition() {
    sessionStorage.setItem("scrollPosition", window.scrollY);
  }

  // Event listener for visibility change
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") {
      saveScrollPosition();
    }
  });

  // Event listener for window scroll
  window.addEventListener("scroll", saveScrollPosition);
  // document.addEventListener('visibilitychange', function() {
  //   if (document.visibilityState === 'hidden') {
  //     sessionStorage.setItem('scrollPosition', window.scrollY);
  //   }
  // });

  window.addEventListener("pageshow", function (event) {
    sessionStorage.removeItem("scrollPosition");
    const savedPosition = sessionStorage.getItem("scrollPosition");
    if (savedPosition) {
      window.scrollTo({
        top: parseInt(savedPosition, 10),
        behavior: "instant",
      });
      sessionStorage.removeItem("scrollPosition");
    }
  });
  // }
} else {
  sessionStorage.removeItem("scrollPosition");
}

document.addEventListener("DOMContentLoaded", function () {
  var sections = document.querySelectorAll("[data-title]");
  var nav = document.querySelector(".tm_grid");
  var nav_height = nav?.offsetHeight + 100;
  if (nav) {
    window.addEventListener("scroll", function () {
      var cur_pos = window.scrollY;
      sections.forEach(function (section) {
        var top = section.offsetTop - nav_height;
        var bottom = top + section.offsetHeight;
        if (cur_pos >= top && cur_pos <= bottom) {
          document.querySelectorAll(".tm_tab").forEach(function (navItem) {
            navItem.classList.remove("active");
          });
          sections.forEach(function (sectionItem) {
            sectionItem.classList.remove("active");
          });

          section.classList.add("active");
          var store = section.getAttribute("data-title");
          var matchingNavItem = document.querySelector(
            `.tm_tab[data-sectiontitle="${store}"]`
          );
          if (matchingNavItem) {
            matchingNavItem.classList.add("active");
          }
        }
      });
    });
  }
});
$(document).ready(function () {
  $(document).on(
    "change",
    '.facets-container .list-menu__item input[type="checkbox"]',
    function () {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: "instant", // This ensures instant scrolling without smooth animation
        });
      }, 700);
    }
  );
});

document.addEventListener("DOMContentLoaded", function () {
  var TM_REVIEW_NAME_SELECTOR =
    "#tm_product_review_form_popup .tm_review_form_name input, " +
    "#tm_question_form_popup .tm_review_form_name input";

  // The shopper's own typing must win - without this, the guard would eat
  // every character after a space as they type.
  var tmReviewNameUserTyped = false;
  document.addEventListener(
    "input",
    function (e) {
      if (
        e.isTrusted &&
        e.target.matches &&
        e.target.matches(TM_REVIEW_NAME_SELECTOR)
      ) {
        tmReviewNameUserTyped = true;
      }
    },
    true
  );

  function tmApplyFirstNameOnly() {
    document.querySelectorAll(TM_REVIEW_NAME_SELECTOR).forEach(function (input) {
      // Rivyo hasn't filled it (or never will on this path) - seed it from
      // the Shopify customer object instead of waiting.
      if (!input.value && window.tmCustomerFirstName) {
        input.value = String(window.tmCustomerFirstName).trim().split(/\s+/)[0];
        return;
      }
      var first = (input.value || "").trim().split(/\s+/)[0];
      if (first && input.value !== first) input.value = first;
    });
  }

  // Polling, not a MutationObserver: Rivyo assigns input.value directly,
  // which fires no mutation record. Runs until the shopper touches the
  // field, or 6s - comfortably past Rivyo's script re-injection + fetch on
  // the Order Details path, which is what the old 800ms cutoff kept losing.
  function tmStartFirstNameGuard() {
    tmReviewNameUserTyped = false;
    clearInterval(window.__wcFirstNameGuard);
    tmApplyFirstNameOnly();

    var elapsed = 0;
    window.__wcFirstNameGuard = setInterval(function () {
      elapsed += 100;
      if (tmReviewNameUserTyped || elapsed > 6000) {
        clearInterval(window.__wcFirstNameGuard);
        return;
      }
      tmApplyFirstNameOnly();
    }, 100);
  }

  function handleButtonClick() {
    document.body.classList.add("tm_popup_open");

    // Product page reads its own heading; Order Details falls back to the
    // name stashed by tmOpenReviewInline() for the clicked line item.
    const productNameElement = document.querySelector(
      ".tm_product-desc .tm_product-name"
    );
    const productName = productNameElement
      ? productNameElement.textContent.trim()
      : window.tmReviewProductName || "";

    const modelElement = document.querySelector(".tm_product-modal .tm_lg-font");
    const model = modelElement ? modelElement.textContent.trim() : "";

    if (productName) {
      const reviewFormStartHTML =
        '<div class="review_product_model">' +
        '<h4 class="tm_product-name">' + productName + "</h4>" +
        (model ? '<p class="tm_model">' + model + "</p>" : "") +
        "</div>";

      ["#tm_product_review_form_popup", "#tm_question_form_popup"].forEach(
        function (popupSel) {
          const popup = document.querySelector(popupSel);
          if (!popup) return;
          const title = popup.querySelector(".tm_review_form_title");
          if (!title) return;
          // Remove-then-insert, not skip-if-present: on Order Details the
          // same popup is reused for a second line item, and the old code's
          // "already exists" guard left the first product's name in place.
          const old = popup.querySelector(".review_product_model");
          if (old) old.remove();
          title.insertAdjacentHTML("afterend", reviewFormStartHTML);
        }
      );
    }

    // Rivyo fills the name field from the logged-in customer after the popup
    // is built, so one pass isn't enough.
    tmStartFirstNameGuard();

    // .tm_review_submit_btn.tm_review_btn no longer exists in the Rivyo
    // app's current markup, so querySelector returned null here and calling
    // .addEventListener on it threw - since that happened before the popup's
    // display:block line in the caller, the whole click handler aborted and
    // the review popup never opened at all.
    var reviewSubmitBtn = document.querySelector(".tm_review_submit_btn.tm_review_btn");
    if (reviewSubmitBtn) {
      reviewSubmitBtn.addEventListener("click", function () { });
    }
  }
  function setupButtons() {
    // .tm_write_review_form / .tm_ask_question_form are injected asynchronously
    // by the Rivyo reviews app (not part of this theme's markup), so they may
    // not exist yet on any single check. Guard each insertion so repeated
    // calls (see the MutationObserver below) don't stack duplicate buttons.
    const tmWriteReview = document.querySelector(".tm_write_review_form");
    const htmlReview =
      '<a class="review_write_click tm_review_btn" href="javascript:void(0)">Write a customer review</a>';
    if (
      tmWriteReview &&
      !(tmWriteReview.nextElementSibling && tmWriteReview.nextElementSibling.classList.contains("review_write_click"))
    ) {
      tmWriteReview.insertAdjacentHTML("afterend", htmlReview);
      const reviewButton = tmWriteReview.nextElementSibling;
      if (reviewButton) {
        reviewButton.addEventListener("click", function () {
          handleButtonClick();
          document.querySelector(
            "#tm_product_review_form_popup"
          ).style.display = "block";
          // var emailInput = document.querySelector('.tm_review_form_email #email_id');
          // if (emailInput) {
          //     emailInput.value = window.customerEmail;
          //     document.querySelector('.tm_review_form_email').style.display = 'none';
          //     document.querySelector('#tm_product_review_form_popup .tm_review_form_name').style.width = '100%';
          // }
        });
      }
    }
    const tmQuestionReview = document.querySelector(".tm_ask_question_form");
    const htmlQuestion =
      '<a class="review_tm_question_review_click tm_review_btn" href="javascript:void(0)">Ask a product question</a>';
    if (
      tmQuestionReview &&
      !(tmQuestionReview.nextElementSibling && tmQuestionReview.nextElementSibling.classList.contains("review_tm_question_review_click"))
    ) {
      tmQuestionReview.insertAdjacentHTML("afterend", htmlQuestion);
      const reviewQuestionButton = tmQuestionReview.nextElementSibling;
      if (reviewQuestionButton) {
        reviewQuestionButton.addEventListener("click", function () {
          handleButtonClick();
          document.querySelector("#tm_question_form_popup").style.display =
            "block";
        });
      }
    }

    // Only trim names that still have more than one word - now that
    // setupButtons() re-runs on every DOM mutation (see observer below),
    // rewriting an already-first-name-only value on every call would itself
    // be a mutation, re-triggering the observer in an endless loop.
    const authorElements = document.querySelectorAll(".tm_review_author_name");
    authorElements.forEach((element) => {
      const characters = element.textContent.split(" ");
      if (characters.length > 1) {
        element.innerText = characters[0];
      }
    });
  }

  setupButtons();
  setTimeout(setupButtons, 1000);
  new MutationObserver(setupButtons).observe(document.body, {
    childList: true,
    subtree: true,
  });
});

// product page scrolltop 0
// window.addEventListener("load", (event) => {
//   var findproduct = document.body.classList.contains('product');
//   if (findproduct){
//     console.log("ifffffffffffffffffffffff");
//     document.querySelector('.main_product_Section_main').scrollTop = 0;
//   }else{
//     console.log("elseeeeeeeeeeeeee");
//   }
// });

// document.addEventListener("DOMContentLoaded", function () {
//   const submitButton = document.querySelector(
//     // '.tm_btn[data-submit="jd-submit"]'
//   );
//   const emailInput = document.querySelector("#ragister_email_id");
//   if (submitButton) {
//     submitButton.addEventListener("click", function (event) {
//       event.preventDefault();
//       const emailValue = emailInput.value.trim();
//       if (emailValue === "") {
//         console.log("Email input is blank!");
//       } else {
//         console.log("Email input value:", emailValue);
//       }
//     });
//   } else {
//     console.log("Submit button not found.");
//   }
// });

document.addEventListener("DOMContentLoaded", function () {
  const submitButton = document.querySelector(
    '.tm_btn[data-submit="jd-submit"]' // Add the selector string here
  );
  const emailInput = document.querySelector("#ragister_email_id");
  if (submitButton) {
    submitButton.addEventListener("click", function (event) {
      event.preventDefault();
      const emailValue = emailInput.value.trim();
      if (emailValue === "") {
        console.log("Email input is blank!");
      } else {
        console.log("Email input value:", emailValue);
      }
    });
  } else {
    console.log("Submit button not found.");
  }
});

if (document.querySelector('cart-drawer .cart__checkout-button')) {
  document.querySelector('cart-drawer .cart__checkout-button').addEventListener('click', function (event) {
    // event.preventDefault();
    // event.stopPropagation();
    // event.stopImmediatePropagation();

    // window.location.href = '/checkout';
  });
}

// Jd code | On the registration page, when the form is filled, the email should be automatically populated in the newsletter form as well, and the customer should be added with the 'subscribe' tag.

// document.addEventListener("DOMContentLoaded", function () {
// setTimeout(function () {
//   const jdregisterData = localStorage.getItem('Register Data');
//   console.log('jdregisterData', jdregisterData);

//   if (jdregisterData) {
//     const parsedData = JSON.parse(jdregisterData);
//     console.log('parsedData', parsedData);

//     if (parsedData.submit_form === true) {
//       const jdemail = parsedData.email;
//       console.log('jdemail', jdemail);
//       const emailInput = document.querySelector('.jd-email-add');
//       console.log('emailInput', emailInput)

//       if (emailInput) {
//         emailInput.value = jdemail;
//       }

//       const submitButton = document.querySelector('.jd-custom-submit');
//       if (submitButton) {
//         submitButton.click();
//         setTimeout(function () {
//           const updatedData = JSON.parse(localStorage.getItem('Register Data'));
//           updatedData.submit_form = false;
//           localStorage.setItem('Register Data', JSON.stringify(updatedData));
//           console.log('Updated Register Data:', updatedData);
//         }, 100);
//       }
//     }
//   }
// }, 1000);
// });


$(document).mouseup(function (e) {
  var clickplace = $(".Wishlist_popup");
  if (clickplace.hasClass("active")) {
    if (!clickplace.is(e.target) && clickplace.has(e.target).length === 0) {
      $(".Create_new_list #New_list").val("");
    }
  }
});

///wishlist //

const addToListButtons = document.querySelectorAll(".tm_add_to-list");
const mobileWishlist = document.querySelectorAll(".mobile_wishlist_button");
const productFormInputs = document.querySelectorAll(".product-form__input");

const updateAttributes = () => {
  const priceElement = document.querySelector(".tm_product-price .main_price");
  const modelElement = document.querySelector(".tm_product-modal span");
  const imageElement = document.querySelector(".tm_pro-main-img");

  const newPrice = priceElement ? priceElement.textContent.trim() : "";
  let newModel = modelElement ? modelElement.textContent.trim() : "";
  const newImageSrc = imageElement ? imageElement.getAttribute("src") : "";

  if (newModel.startsWith("Model:")) {
    newModel = newModel.replace(/^Model:\s*/, "");
  }

  if (addToListButtons.length > 0) {
    addToListButtons.forEach((button) => {
      button.setAttribute("data-productprice", newPrice);
      button.setAttribute("data-productmodel", newModel);
      button.setAttribute("data-src", newImageSrc);
    });
  }
  if (mobileWishlist.length > 0) {
    mobileWishlist.forEach((button) => {
      button.setAttribute("data-productprice", newPrice);
      button.setAttribute("data-productmodel", newModel);
      button.setAttribute("data-src", newImageSrc);
    });
  }
  const amazonWishlistButtons = document.querySelectorAll(".amazon_wishlist_trigger");
  if (amazonWishlistButtons.length > 0) {
    amazonWishlistButtons.forEach((button) => {
      button.setAttribute("data-productprice", newPrice);
      button.setAttribute("data-productmodel", newModel);
      button.setAttribute("data-src", newImageSrc);
    });
  }
};


if (productFormInputs.length > 0) {
  productFormInputs.forEach((input) => {
    input.addEventListener("change", () => {
      setTimeout(updateAttributes, 200);
    });
  });
}

updateAttributes();


document.addEventListener("DOMContentLoaded", function () {
  // "Write a product review" from Order Details, WITHOUT leaving Order
  // Details at all - the client explicitly rejected both a same-tab
  // navigation and a new-tab navigation (both tried first) as "it still
  // redirects to the product page".
  //
  // An iframe overlay was tried too (kept Order Details open behind a
  // modal) but Shopify sends X-Frame-Options: DENY + frame-ancestors
  // 'none' on every storefront page, platform-wide - no Shopify page can
  // be framed, by us or anyone else, so that's a dead end regardless of
  // theme code.
  //
  // What actually works: Rivyo's whole review widget (sections/
  // left_section_reminder.liquid) is just an empty
  // #tm_review_section[data-handle][data-product_id] div that Rivyo's own
  // script (loaded site-wide via app embed - inspect any page's <script
  // src="...tm-product-review.js...">) scans for and AJAX-fills in. That
  // scan only runs ONCE though, synchronously the first time the script
  // itself executes (gated behind a one-shot flag inside the script, not
  // something exposed for us to call again) - which already happened on
  // THIS page load, before any review button was even clicked, and found
  // nothing (no #tm_review_section exists outside the product page
  // template).
  //
  // The script also guards its own top-level body with
  // `if (window.th_product_rivyo === undefined)`, skipping everything if
  // it's already run once in this window. So: build our own
  // #tm_review_section with the clicked product's handle/id, clear that
  // guard, and re-inject a FRESH copy of the exact same script src - its
  // top-level code (including the one-shot scan) runs again from scratch,
  // finds our div this time, and fills it in. All without a single
  // navigation.
  function tmRivyoScriptSrc() {
    var existing = document.querySelector('script[src*="tm-product-review.js"]');
    if (!existing) return null;
    return existing.src.split("&_cb=")[0].split("?_cb=")[0];
  }

  // Kept off-screen (see .tm_review_inline_overlay in style.css) - it only
  // needs to exist for Rivyo's script to find #tm_review_section and for
  // the "Write a customer review" button inside it to be clickable. Rivyo's
  // OWN popup (#tm_product_review_form_popup) is what actually gets shown
  // to the shopper, appended straight to <body> by its own script - showing
  // this wrapper too stacked an unwanted second "Customer Reviews" panel
  // behind/with it.
  var tmReviewOverlay, tmReviewSection;

  function tmBuildReviewOverlay() {
    if (tmReviewOverlay) return;
    tmReviewOverlay = document.createElement("div");
    tmReviewOverlay.className = "tm_review_inline_overlay";
    tmReviewOverlay.innerHTML =
      '<div id="Reviews" class="tm_product-review tm_product-border">' +
      '<div class="tm_container"><div id="tm_review_section" class="tm_review_main_content"></div></div>' +
      "</div>";
    document.body.appendChild(tmReviewOverlay);
    tmReviewSection = tmReviewOverlay.querySelector("#tm_review_section");
  }

  function tmAutoClickWriteReview() {
    var checkBtn = setInterval(function () {
      var reviewBtn = document.querySelector(".review_write_click");
      if (reviewBtn) {
        reviewBtn.click();
        sessionStorage.removeItem("product_review");
        clearInterval(checkBtn);
      }
    }, 300);
  }

  function tmOpenReviewInline(btn) {
    var productId = btn.getAttribute("data-product-id");
    var productHandle = btn.getAttribute("data-product-handle");
    var scriptSrc = tmRivyoScriptSrc();
    window.tmReviewProductName = btn.getAttribute("data-product-title") || "";
    // Missing what we need to drive Rivyo directly (older cached markup
    // without the data attributes, or the app embed somehow not present on
    // this page) - fall back to a real navigation rather than show a
    // broken/empty popup.
    if (!productId || !productHandle || !scriptSrc) {
      sessionStorage.setItem("product_review", "true");
      window.location.href = btn.getAttribute("href");
      return;
    }

    tmBuildReviewOverlay();
    tmReviewSection.innerHTML = "";
    tmReviewSection.setAttribute("data-url", window.location.origin);
    tmReviewSection.setAttribute("data-handle", productHandle);
    tmReviewSection.setAttribute("data-product_id", productId);
    tmReviewSection.setAttribute("data-limit", "0");

    delete window.th_product_rivyo;
    var s = document.createElement("script");
    s.src = scriptSrc + (scriptSrc.indexOf("?") > -1 ? "&" : "?") + "_cb=" + Date.now();
    s.onload = tmAutoClickWriteReview;
    document.body.appendChild(s);
  }

  document.querySelectorAll(".jd_review_btn").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      tmOpenReviewInline(btn);
    });
  });

  // Fallback path only: if tmOpenReviewInline() above had to fall back to a
  // real navigation (missing data), this still picks up the review popup
  // once the product page itself loads - same as it always has.
  if (sessionStorage.getItem("product_review") === "true") {
    tmAutoClickWriteReview();
  }
});


// Open external links and downloadable files (PDFs, datasheets, etc.) in a
// new tab, so opening a document doesn't lose the shopper's place on the
// page. Internal site navigation stays in the same tab. Event delegation
// (checked at click time, not pre-scanned on load) so it also covers links
// added later by AJAX/popups (search, wishlist, filters).
const tmExternalFileExtension = /\.(pdf|docx?|xlsx?|pptx?|zip|rar|csv|txt)(\?|#|$)/i;
document.addEventListener("click", function (e) {
  const link = e.target.closest("a[href]");
  if (!link || link.target) return;

  const href = link.getAttribute("href") || "";
  if (
    !href ||
    href.startsWith("#") ||
    href.toLowerCase().startsWith("javascript:") ||
    href.toLowerCase().startsWith("mailto:") ||
    href.toLowerCase().startsWith("tel:")
  ) {
    return;
  }

  let isExternal = false;
  try {
    isExternal = new URL(href, window.location.href).hostname !== window.location.hostname;
  } catch (err) {
    isExternal = false;
  }

  if (isExternal || tmExternalFileExtension.test(href)) {
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener");
  }
});
